import { render, staticRenderFns } from "./FieldWysiwyg.vue?vue&type=template&id=09145161"
import script from "./FieldWysiwyg.vue?vue&type=script&lang=js"
export * from "./FieldWysiwyg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports